import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Moment } from 'moment';
export interface DeliveryState {
  displayDeliveryFeeModal: boolean;
  deliveryQuoteError: string | null;
  deliveryQuoteExpiryTime: null | Moment;
  deliveryQuoteLoading: boolean;
}

const initialState: DeliveryState = {
  displayDeliveryFeeModal: false,
  deliveryQuoteError: null,
  deliveryQuoteExpiryTime: null,
  deliveryQuoteLoading: false,
};

export const deliverySlice = createSlice({
  name: 'delivery',
  initialState,
  reducers: {
    setDeliveryQuoteModal: (state, action: PayloadAction<boolean>) => {
      state.displayDeliveryFeeModal = action.payload;
      if (!action.payload) state.deliveryQuoteError = null;
    },
    setDeliveryQuoteError: (state, action: PayloadAction<string | null>) => {
      state.deliveryQuoteError = action.payload;
    },
    setDeliveryQuoteExpiryTime: (state, action: PayloadAction<Moment>) => {
      state.deliveryQuoteExpiryTime = action.payload;
    },
    setDeliveryQuoteLoading: (state, action: PayloadAction<boolean>) => {
      state.deliveryQuoteLoading = action.payload;
    },
    resetDeliverySlice: (state) => {
      state.displayDeliveryFeeModal = false;
      state.deliveryQuoteError = null;
      state.deliveryQuoteExpiryTime = null;
      state.deliveryQuoteLoading = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDeliveryQuoteModal,
  setDeliveryQuoteError,
  setDeliveryQuoteExpiryTime,
  setDeliveryQuoteLoading,
  resetDeliverySlice,
} = deliverySlice.actions;

export default deliverySlice.reducer;
